const T = require("react").PropTypes;

const ErrorType = require("./Error.js").PropType;

const WalkThru = {
    PropType: T.shape({
        SurveyID: T.string,
        SurveyType: T.string,
        SurveyFacilityNumber: T.string,
        IsLoading: T.bool.isRequired,
        LoadError: ErrorType,
        Data: T.shape({
            FacNumber: T.string,
            FacName: T.string,
            Created: T.object,
            Entries: T.arrayOf(
                T.arrayOf(T.string))
        })
    })
};

module.exports = WalkThru;


// WEBPACK FOOTER //
// ./src/types/WalkThru.js